import React from "react";

function DsaContentPlaceholderIcon() {
  return (
    <svg
      className="placeholder-svg"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="33"
      fill="none"
      viewBox="0 0 32 33"
    >
      <g>
        <path
          fill="#CFCFCF"
          d="M28.071 6.25H3.93A.918.918 0 003 7.16v18.18c0 .504.415.91.929.91H28.07a.918.918 0 00.929-.91V7.16a.918.918 0 00-.929-.91zm-1.16 17.954H5.089v-1.133l4.02-4.668 4.355 5.057 6.775-7.863 6.672 7.744v.863zm0-3.687l-6.495-7.54a.234.234 0 00-.354 0l-6.598 7.66-4.179-4.85a.234.234 0 00-.354 0l-3.842 4.46V8.295h21.822v12.222zM9.964 14.659c.336 0 .668-.065.977-.19.31-.126.592-.31.829-.542.237-.232.425-.508.553-.811a2.455 2.455 0 00-.553-2.725 2.558 2.558 0 00-.829-.542 2.601 2.601 0 00-2.782.542 2.474 2.474 0 00-.748 1.768c0 .663.269 1.299.748 1.768a2.582 2.582 0 001.805.732zm0-3.295c.45 0 .813.355.813.795 0 .44-.363.795-.813.795a.803.803 0 01-.812-.795c0-.44.363-.795.812-.795z"
        ></path>
      </g>
    </svg>
  );
}

export default DsaContentPlaceholderIcon;
